export default __webpack_public_path__ + "04ae4f7ee7e64d769f5fdc3d0d13c78b.svg";